export default "__VITE_ASSET__DTKkl2o9__"